<script>
import CustomPagination from "@/driver/components/_CustomPagination.vue";

export default {
  name: "FlowBlock",
  components: {CustomPagination},
  props: {
    pagination: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 50,
    }
  },
  data () {
    return {
      totalVisible: 7,
      headers: [
        { value: 'pattern_name', text: "コード\r\nパターン名\r\n処分前廃棄物種類", width: "16%" },
        { value: 'disposer', text: "処分事業者\r\n処分事業場\r\n住所", width: "16%" },
        { value: 'before_ratio', text: "按分割合\r\n処分方法", width: "26%" },
        { value: 'output_type', text: "処理後割合\r\n処理後物の種類", width: "26%" },
        { value: 'sort_priority', text: "表示順\r\n非表示", width: "4%" },
        { value: 'actions', text: "詳細・編集", align: 'end', width: "7%" },
      ],
    }
  },
  methods: {

    /**
     * ページ チェンジコールバック
     * @param page { Number } ページ番号
     */
    pageChangeCallback (page) {
      this.$emit("pageChanged", page);
    },

    /**
     * 表示件数 チェンジコールバック
     * @param perPage { Number } 一覧表示件数
     */
    perPageChangeCallback (perPage) {
      this.$emit("perPageChanged", perPage);
    },

    /**
     * 参照ボタン クリックイベント
     * @param item { Object }
     */
    showButtonClickEvent (item) {
      this.$router.push({ name: "DriverMasterFlow", params: { id: item.id } });
    },

    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.$router.push({ name: "DriverMasterFlowEdit", params: { id: item.id } });
    },
    /**
     * 工程の背景色を設定
     * @param member
     * @return {string}
     */
    levelBackgroundColor (member) {
      if (member.level === 1) {
        return 'primary_level'
      } else if (member.level === 2) {
        return 'secondary_level'
      } else {
        return 'tertiary_level'
      }
    },
  }
}
</script>

<template>
  <div>

    <v-row class="white">
      <v-col
        cols="12"
        md="6"
        style="vertical-align: middle"
      >
        <div>
          <small>処分場処理方法&nbsp;&nbsp;:&nbsp;&nbsp;１つの処分場での処理内容を登録します。</small><br>
          <small>処理フロー&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;処分場の処理内容を組み合わせて一連の流れ（フロー）を作成します。</small>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

    <v-sheet class="mt-5 mb-5" rounded>

      <v-data-table
        :headers="headers"
        :items="items"
        disable-sort
        :items-per-page="-1"
        hide-default-footer
      >
        <!-- パターンコード／パターン名／処分前廃棄物種類 -->
        <template v-slot:[`item.pattern_name`]="{ item }">
          <div style="height: 100%;vertical-align: top">
            <div>{{ item.code }}</div>
            <div class="line-clamp one-clamp">{{ item.pattern_name }}</div>
            <div v-if="item.item_name">
              <v-chip
                color="#F0E6D0"
                drak
                label
                x-small
                class="chip-ellipsis mb-1"
              >
                {{ item.item_name }}
              </v-chip>
              <small><span v-if="item.item_name_count > 0">&emsp;全&nbsp;{{ item.item_name_count }}件</span></small>
            </div>
          </div>
        </template>
        <!-- /パターンコード／パターン名／処分前廃棄物種類 -->

        <!-- 処分事業者／処分事業場／住所 -->
        <template v-slot:[`item.disposer`]="{ item }">
          <div style="display: flex; align-items: center; gap: 4px;">
            <v-img
              v-if="item.use_station"
              max-height="18"
              max-width="18"
              :src="require(`@/assets/images/DXE_mark.svg`)"
            />
            <span :title="item.disposer_name" class="line-clamp one-clamp">{{ item.disposer_name }} </span>
          </div>
          <div style="display: flex; align-items: center; gap: 4px;">
            <v-img
              v-if="item.use_station"
              max-height="18"
              max-width="18"
              :src="require(`@/assets/images/DXE_mark.svg`)"
            />
            <span :title="item.disposer_location_name" class="line-clamp one-clamp">{{ item.disposer_location_name }} </span>
          </div>
          <div class="line-clamp one-clamp">
            <small class="text--disabled">
              {{ item.disposer_location_address }}&nbsp;
            </small>
          </div>
        </template>
        <!-- /処分事業者／処分事業場／住所 -->

        <!-- 処分方法／按分割合 -->
        <template v-slot:[`item.before_ratio`]="{ item }">
          <div style="height: 100%;vertical-align: top">
            <div style="height: 100%;vertical-align: top">
              <div v-for="(value, key) in item.recycle_disposal_flow_details" :key="key">
                <div class="d-flex align-center">
                  <v-chip
                    class="justify-center mr-2"
                    :class="levelBackgroundColor(value)"
                    x-small
                  >
                    {{ `${value.level}`.padStart(2, '0') }}
                  </v-chip>
                  <span class="line-clamp one-clamp">
                    {{ value.before_disposal_ratio }}&#37;&nbsp;
                    {{ value.recycle_disposal_method_name }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- /処分方法／按分割合 -->

        <!-- 処理後割合／処理後物の種類 -->
        <template v-slot:[`item.output_type`]="{ item }">
          <div style="height: 100%;vertical-align: top">
            <div v-for="(value, key) in item.recycle_disposal_flow_details" :key="key">
              <div class="line-clamp one-clamp">
                {{ value.after_disposal_ratio }}&#37;&nbsp;
                {{ value.recycle_disposed_item_name || ' ' }}&nbsp;
                <small>
                  <span class="text--disabled">
                    {{ value.after_type_label }}<span v-if="value.final_disposal">(最終)</span>
                  </span>
                </small>
              </div>
            </div>
          </div>
        </template>
        <!-- /処理後割合／処理後物の種類 -->

        <!-- 種別／中間or最終 -->
        <!-- <template v-slot:[`item.after_type`]="{ item }">
          <div style="height: 100%;vertical-align: top">
            <div v-for="(value, key) in item.recycle_disposal_flow_details" :key="key">
              <div>{{ value.after_type_label }}<span v-if="value.final_disposal">(最終)</span></div>
            </div>
          </div>
        </template> -->
        <!-- /種別／中間or最終 -->

        <!-- 表示順・非表示 -->
        <template v-slot:[`item.sort_priority`]="{ item }">
          <div>
            <div>{{ item.sort_priority }}</div>
          </div>
          <div>
            <span v-if="item.invisible">非表示</span>
            <span v-else>&nbsp;</span>
          </div>
        </template>
        <!-- /表示順・非表示 -->

        <template v-slot:[`item.actions`]="{ item }">
          <div>
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              icon
              color="info darken-2"
              @click="showButtonClickEvent(item)"
            >
              <v-icon>mdi-file-document-outline</v-icon>
            </v-btn>
            <v-btn
              v-else
              text
              color="info"
              @click="showButtonClickEvent(item)"
            >
              参照
            </v-btn>
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              color="info darken-2"
              icon
              @click="editButtonClickEvent(item)"
            >
              <v-icon>mdi-note-edit</v-icon>
            </v-btn>
            <v-btn
              v-else
              text
              color="info"
              @click="editButtonClickEvent(item)"
            >
              編集
            </v-btn>
          </div>

        </template>

      </v-data-table>

    </v-sheet>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="pageChangeCallback"
          @perPageChanged="perPageChangeCallback"
        />
      </v-col>
    </v-row>

  </div>
</template>

<style scoped lang="scss">

.primary_level { background-color: #00aad1 !important; color: white !important; }
.secondary_level { background-color: #86b1c1 !important; color: white !important; }
.tertiary_level { background-color: #afafaf !important; color: white !important; }


</style>
